import initializeRecaptcha from './recaptcha-init';

document.addEventListener('DOMContentLoaded', () => {
  // Select all forms with the class "contact-form-ajax"
  const contactForms = document.querySelectorAll('form.contact-form-ajax');
  if (!contactForms) {
    return;
  }

  const showConfirmation = (id, message = '', success = true) => {
    const modal = document.getElementById(`confirmation_${id}`);
    if (!modal) {
      return;
    }

    const messageElement = modal.querySelector('.flexible-contact-form-confirmation__message');
    const titleElement = modal.querySelector('.flexible-contact-form-confirmation__title');
    const title = success ? modal.dataset.titleSuccess : modal.dataset.titleError;

    if (message) {
      messageElement.innerHTML = message;
    }

    if (title) {
      titleElement.innerHTML = title;
    }

    modal.showModal();
  }

  contactForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const id = form.getAttribute('data-id');
      const formData = new FormData(form);
      const actionUrl = form.getAttribute('action');
      const method = form.getAttribute('method');

      // Add loading class to the form
      form.classList.add('loading');

      // Send AJAX request using Fetch
      fetch(actionUrl, {
        method: method,
        body: formData,
      })
        .then((response) => response.json()) // Parse JSON response
        .then((result) => {
          form.classList.remove('loading');
          if (result.success) {
            showConfirmation(id, result.message, true);
            form.reset();
          } else {
            showConfirmation(id, result.message, false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          form.classList.remove('loading');
        })
        .finally(() => {
          initializeRecaptcha();
        });
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/components/contact-form-ajax.js